import React, {FC} from 'react';
import {Flex, Text} from '@priority-software/priority-style-react';
import styles from './RouteTile.module.scss';
import {ColumnsNamesForRoutes} from '../../constants';
import {Form, Record} from '../../../../stores/Form';

type SummaryProps = {
    name: string;
    value: string | number | boolean;
};

type RouteTotalsSectionProps = {
    routeData: Record;
    routesForm: Form;
    colNames: ColumnsNamesForRoutes[];
};

const Summary: FC<SummaryProps> = ({name, value}) => {
    return (
        <Flex componentClasses={styles.summary} alignItems={'center'} justifyContent={'flex-start'}>
            <Text skin={'paragraph-2'} textColor={'secondary-500'}>
                {name}:
            </Text>
            <Text
                skin={'paragraph-2'}
                textColor={'primary-700'}
                componentClasses={styles.selectableText}
            >
                {value}
            </Text>
        </Flex>
    );
};

export const RouteTotalsSection = ({routeData, routesForm, colNames}: RouteTotalsSectionProps) => {
    return (
        <>
            {colNames.map(colName => {
                return (
                    <Summary
                        key={colName}
                        name={routesForm.getColumnByName(colName)?.Title}
                        value={
                            routeData.getField(routesForm.getColumnByName(colName)?.ID as number)
                                ?.currentValue || 0
                        }
                    />
                );
            })}
        </>
    );
};
